import React, { useEffect, useRef, useState } from 'react';


export const PrivateGalleryImage = ({ path, token, alt, className = '', testId = 'private-gallery-image' }) => {
  const [src, setSrc] = useState('');
  const [state, setState] = useState('loading');
  const [enlarged, setEnlarged] = useState('');
  const triggerRef = useRef(null);
  const closeRef = useRef(null);
  // Gallery API paths use the current website, just like authenticated uploads.
  const apiPath = path;

  useEffect(() => {
    let active = true;
    let objectUrl = '';
    setState('loading');
    fetch(apiPath, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        if (!response.ok) throw new Error('Private image unavailable');
        return response.blob();
      })
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        if (active) { setSrc(objectUrl); setState('ready'); }
      })
      .catch(() => { if (active) { setSrc(''); setState('error'); } });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [apiPath, token]);

  const openOriginal = async () => {
    const originalPath = apiPath?.replace('/thumbnail', '/original');
    const response = await fetch(originalPath, { headers: { Authorization: `Bearer ${token}` } });
    if (!response.ok) return;
    setEnlarged(URL.createObjectURL(await response.blob()));
  };

  const close = () => { if (enlarged) URL.revokeObjectURL(enlarged); setEnlarged(''); };

  useEffect(() => {
    if (!enlarged) return undefined;
    closeRef.current?.focus();
    const handleKeyDown = (event) => { if (event.key === 'Escape') close(); };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      triggerRef.current?.focus();
    };
  }, [enlarged]);

  if (!src) return <div className={`${className} flex items-center justify-center bg-slate-100 p-3 text-center text-xs text-slate-500`} data-testid={`${testId}-${state}`}>{state === 'error' ? 'Private image unavailable' : 'Loading private image…'}</div>;
  return <>
    <button ref={triggerRef} type="button" onClick={openOriginal} aria-label={`Enlarge ${alt}`} className="block w-full cursor-zoom-in focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#7c2434]" data-testid={`${testId}-enlarge-button`}><img src={src} alt={alt} className={className} data-testid={testId} /></button>
    {enlarged && <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/85 p-5" role="dialog" aria-modal="true" aria-label={`Enlarged view of ${alt}`} data-testid={`${testId}-lightbox`}><button ref={closeRef} type="button" onClick={close} className="absolute right-5 top-5 border border-white px-3 py-2 text-sm font-semibold text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" data-testid={`${testId}-close-button`}>Close</button><img src={enlarged} alt={alt} className="max-h-[85vh] max-w-[92vw] object-contain" data-testid={`${testId}-enlarged-image`} /></div>}
  </>;
};